// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"562":"accounts","768":"page"}[chunkId] + "." + {"562":"bcde2c7b","768":"f30a06f1"}[chunkId] + ".chunk.css";
};